import { useState } from 'react'

import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import Typography from '@mui/material/Typography'

import { SelectString } from '../../../../core/components/SelectString'
import { StyledError } from '../../../../theme/components/StyledError'
import { useUpdateSubprocesForEntity } from '../../hooks/useUpdateSubprocesForEntity'
import type { Subproces } from '../../types/Subproces'
import { SCHOUW_CANCEL_REDENEN } from '../../types/SubprocesRedenen'

interface Props {
  subproces: Subproces
  onClose: () => void
}

export const CancelSchouw = ({ subproces, onClose }: Props) => {
  const { mutate: updateSubprocesForEntity, error } =
    useUpdateSubprocesForEntity()
  const [reden, setReden] = useState<
    (typeof SCHOUW_CANCEL_REDENEN)[number] | null
  >(null)

  const onSubmitClick = () => {
    const proces: Partial<Subproces & { text: string }> = {
      _id: subproces._id,
      status: 'cancelled',
      // @ts-expect-error button is disabled when reden is null
      text: reden,
    }

    const body = {
      entity: subproces.entity,
      subprocesInfo: proces,
    }

    updateSubprocesForEntity(body, { onSuccess: () => onClose() })
  }

  return (
    <>
      <DialogContent>
        <StyledError error={error} />
        <Typography sx={{ mb: 2 }}>
          Wat is de reden van de annulering?
        </Typography>

        <SelectString
          value={reden}
          onChange={setReden}
          fullWidth
          options={SCHOUW_CANCEL_REDENEN}
          label="Reden van annulering"
        />
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={onClose} autoFocus>
          Annuleren
        </Button>
        <Button onClick={onSubmitClick} variant={'contained'} disabled={!reden}>
          Bevestigen
        </Button>
      </DialogActions>
    </>
  )
}
